(() => {
  function initialiseSampleRequest() {
    const root = document.querySelector(
      "[data-cs-sample-request]"
    );

    const dataElement = document.getElementById(
      "cs-sample-product-data"
    );

    if (!root || !dataElement) return;

    const ANY_VALUE = "__any__";

const RAL_NAME_OVERRIDES = {
  "1013": "Oyster White RAL 1013",
  "1015": "Light Ivory RAL 1015",
  "1023": "Traffic Yellow RAL 1023",
  "2004": "Pure Orange RAL 2004",
  "3009": "Oxide Red RAL 3009",
  "3020": "Traffic Red RAL 3020",
  "5002": "Ultramarine Blue RAL 5002",
  "5012": "Light Blue RAL 5012",
  "5022": "Night Blue RAL 5022",
  "6005": "Moss Green RAL 6005",
  "6024": "Traffic Green RAL 6024",
  "7016": "Anthracite Grey RAL 7016",
  "7022": "Umbra Grey RAL 7022",
  "7035": "Light Grey RAL 7035",
  "7042": "Traffic Grey RAL 7042",
  "8011": "Nut Brown RAL 8011",
  "9003": "Signal White RAL 9003",
  "9005": "Jet Black RAL 9005"
};

function normaliseColourName(colourName) {
  const ralMatch = colourName.match(
    /\bRAL\s*(\d{4})\b/i
  );

  if (
    ralMatch &&
    RAL_NAME_OVERRIDES[ralMatch[1]]
  ) {
    return RAL_NAME_OVERRIDES[ralMatch[1]];
  }

  return colourName;
}

let rawData;

    try {
      rawData = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error("Sample data could not be read.", error);
      return;
    }

    function sortColours(a, b) {
      const aRal = a.match(/\bRAL\s*(\d{4})\b/i);
      const bRal = b.match(/\bRAL\s*(\d{4})\b/i);

      if (aRal && bRal) {
        return Number(aRal[1]) - Number(bRal[1]);
      }

      if (aRal) return -1;
      if (bRal) return 1;

      return a.localeCompare(b);
    }

    function prepareProducts(products) {
      return products
        .map((product) => {
          const colourOptionIndex =
            product.optionNames.findIndex(
              (optionName) =>
                optionName.toLowerCase() === "colour"
            );

          if (colourOptionIndex === -1) {
            return null;
          }

          const colours = new Map();

          product.variants.forEach((variant) => {
  const variantColourName =
    variant.options[colourOptionIndex];

  if (!variantColourName) return;

  const displayColourName =
    normaliseColourName(variantColourName);

  if (colours.has(displayColourName)) return;

  colours.set(displayColourName, {
    name: displayColourName,
    variantColourName: variantColourName,
    variantId: variant.id,
    image: variant.image || product.image
  });
});

          return {
            id: String(product.id),
            title: product.title,
            handle: product.handle,
            url: product.url,
            image: product.image,
            colours: Array.from(colours.values()).sort(
              (a, b) => sortColours(a.name, b.name)
            )
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.title.localeCompare(b.title));
    }

    const products = prepareProducts(rawData.products);
    const colourProducts = new Map();

    products.forEach((product) => {
      product.colours.forEach((colour) => {
        if (!colourProducts.has(colour.name)) {
          colourProducts.set(colour.name, []);
        }

        colourProducts.get(colour.name).push(product);
      });
    });

    const allColours = Array.from(
      colourProducts.keys()
    ).sort(sortColours);

    root.innerHTML = `
      <div class="cs-sample-selector">
        <div class="cs-sample-selector__intro">
          <h1>Request a Free Sample</h1>

          <p>
            Looking to check a colour match or make sure a screw is right for your application? 
          </p>
          <p>
          Choose one of the options below to get started.
          </p>
        </div>

        <div
          class="cs-sample-selector__modes"
          role="group"
          aria-label="Choose how to find your sample"
        >
          <button
            type="button"
            class="cs-sample-selector__mode is-active"
            data-cs-sample-mode="colour"
            aria-pressed="true"
          >
            Choose a Colour
          </button>

          <button
            type="button"
            class="cs-sample-selector__mode"
            data-cs-sample-mode="screw"
            aria-pressed="false"
          >
            Choose a Screw
          </button>
        </div>

        <div class="cs-sample-selector__fields">
          <div class="cs-sample-selector__field">
            <label for="cs-sample-first-select">
              Choose a colour
            </label>

            <select id="cs-sample-first-select">
              <option value="">Select a colour</option>
            </select>
          </div>

          <div
            class="cs-sample-selector__field"
            data-cs-second-field
            hidden
          >
            <label for="cs-sample-second-select">
              Choose a Screw
            </label>

            <select
              id="cs-sample-second-select"
              disabled
            >
              <option value="">Select a Screw</option>
            </select>
          </div>
        </div>

        <div
          class="cs-sample-selector__selection"
          data-cs-sample-selection
          hidden
        >
          <div class="cs-sample-selector__image-wrapper">
            <img
              class="cs-sample-selector__image"
              data-cs-selection-image
              alt=""
            >
          </div>

          <div class="cs-sample-selector__selection-details">
            <p class="cs-sample-selector__eyebrow">
              Your sample
            </p>

            <h2 data-cs-selection-product></h2>

            <p data-cs-selection-colour></p>

            <p class="cs-sample-selector__ready">
              Selection ready
            </p>
          </div>
        </div>
      </div>
    `;

    const modeButtons = root.querySelectorAll(
      "[data-cs-sample-mode]"
    );

    const firstSelect = root.querySelector(
      "#cs-sample-first-select"
    );

    const secondSelect = root.querySelector(
      "#cs-sample-second-select"
    );

    const secondField = root.querySelector(
      "[data-cs-second-field]"
    );

    const firstLabel = root.querySelector(
      'label[for="cs-sample-first-select"]'
    );

    const secondLabel = root.querySelector(
      'label[for="cs-sample-second-select"]'
    );

    const selection = root.querySelector(
      "[data-cs-sample-selection]"
    );

    const selectionImage = root.querySelector(
      "[data-cs-selection-image]"
    );

    const selectionProduct = root.querySelector(
      "[data-cs-selection-product]"
    );

    const selectionColour = root.querySelector(
      "[data-cs-selection-colour]"
    );

    const sampleForm = document.querySelector(
      "[data-cs-sample-form]"
    );

    const contactForm = sampleForm
      ? sampleForm.closest("form")
      : null;

    const formSelectionMethod = document.querySelector(
      "[data-cs-form-selection-method]"
    );

    const formProduct = document.querySelector(
      "[data-cs-form-product]"
    );

    const formColour = document.querySelector(
      "[data-cs-form-colour]"
    );

    const formProductId = document.querySelector(
      "[data-cs-form-product-id]"
    );

    const formVariantId = document.querySelector(
      "[data-cs-form-variant-id]"
    );

    const formProductUrl = document.querySelector(
      "[data-cs-form-product-url]"
    );

    let mode = "colour";
    let selectedProduct = null;
    let selectedColour = null;

    function addOption(select, value, label) {
      const option = document.createElement("option");

      option.value = value;
      option.textContent = label;

      select.appendChild(option);
    }

    function resetSelect(select, placeholder) {
      select.innerHTML = "";
      addOption(select, "", placeholder);
    }

    function findProduct(productId) {
      return products.find(
        (product) => product.id === productId
      );
    }

    function findColour(product, colourName) {
      if (!product) return null;

      return product.colours.find(
        (colour) => colour.name === colourName
      );
    }

    function hideSelection() {
      selection.hidden = true;

      if (sampleForm) {
        sampleForm.hidden = true;
      }

      selectedProduct = null;
      selectedColour = null;
    }

    function populateForm() {
      if (!selectedProduct || !selectedColour) return;

      if (formSelectionMethod) {
        formSelectionMethod.value =
          mode === "screw"
            ? "Chose by screw"
            : "Chose by colour";
      }

      if (formProduct) {
        formProduct.value = selectedProduct.title;
      }

      if (formColour) {
        formColour.value = selectedColour.name;
      }

      if (formProductId) {
        formProductId.value =
          selectedProduct.id || "";
      }

      if (formVariantId) {
        formVariantId.value =
          selectedColour.variantId || "";
      }

      if (formProductUrl) {
        formProductUrl.value = selectedProduct.url
          ? new URL(
              selectedProduct.url,
              window.location.origin
            ).href
          : "";
      }

      if (sampleForm) {
        sampleForm.hidden = false;
      }
    }

    function showSelection() {
      if (!selectedProduct || !selectedColour) {
        selection.hidden = true;
        return;
      }

      selectionProduct.textContent =
        selectedProduct.title;

      selectionColour.textContent =
        selectedColour.name;

      const image =
        selectedColour.image ||
        selectedProduct.image;

      if (image) {
        selectionImage.src = image;
        selectionImage.alt =
          `${selectedProduct.title} — ${selectedColour.name}`;

        selectionImage.parentElement.hidden = false;
      } else {
        selectionImage.removeAttribute("src");
        selectionImage.parentElement.hidden = true;
      }

      selection.dataset.productId =
        selectedProduct.id || "";

      selection.dataset.productTitle =
        selectedProduct.title;

      selection.dataset.productUrl =
        selectedProduct.url || "";

      selection.dataset.colour =
        selectedColour.name;

      selection.dataset.variantId =
        selectedColour.variantId || "";

      selection.hidden = false;

      populateForm();
    }

    function populateFirstSelect() {
      hideSelection();

      secondField.hidden = true;
      secondSelect.disabled = true;

      if (mode === "screw") {
        firstLabel.textContent = "Choose a Screw";
        secondLabel.textContent = "Pick a Colour";

        resetSelect(
          firstSelect,
          "Select a Screw"
        );

        resetSelect(
          secondSelect,
          "Select a Colour"
        );

        products.forEach((product) => {
          addOption(
            firstSelect,
            product.id,
            product.title
          );
        });
      } else {
        firstLabel.textContent = "Pick a Colour";
        secondLabel.textContent = "Choose a Screw";

        resetSelect(
          firstSelect,
          "Select a Colour"
        );

        resetSelect(
          secondSelect,
          "Select a Screw"
        );

        allColours.forEach((colour) => {
          addOption(
            firstSelect,
            colour,
            colour
          );
        });
      }
    }

    function populateSecondSelect() {
      hideSelection();

      if (!firstSelect.value) {
        secondField.hidden = true;
        secondSelect.disabled = true;
        return;
      }

      secondField.hidden = false;
      secondSelect.disabled = false;

      if (mode === "screw") {
        const product = findProduct(
          firstSelect.value
        );

        resetSelect(
          secondSelect,
          "Select a Colour"
        );

        addOption(
          secondSelect,
          ANY_VALUE,
          "Any Colour"
        );

        if (!product) return;

        product.colours.forEach((colour) => {
          addOption(
            secondSelect,
            colour.name,
            colour.name
          );
        });
      } else {
        const matchingProducts =
          colourProducts.get(firstSelect.value) || [];

        resetSelect(
          secondSelect,
          "Select a Screw"
        );

        addOption(
          secondSelect,
          ANY_VALUE,
          "Any Screw"
        );

        matchingProducts.forEach((product) => {
          addOption(
            secondSelect,
            product.id,
            product.title
          );
        });
      }
    }

    function updateSelection() {
      if (!secondSelect.value) {
        hideSelection();
        return;
      }

      if (mode === "screw") {
        selectedProduct = findProduct(
          firstSelect.value
        );

        if (secondSelect.value === ANY_VALUE) {
          selectedColour = {
            name: "Any Colour",
            variantId: "",
            image: selectedProduct
              ? selectedProduct.image
              : null
          };
        } else {
          selectedColour = findColour(
            selectedProduct,
            secondSelect.value
          );
        }
      } else {
        const matchingProducts =
          colourProducts.get(firstSelect.value) || [];

        if (secondSelect.value === ANY_VALUE) {
          const representativeProduct =
            matchingProducts[0] || null;

          const representativeColour =
            findColour(
              representativeProduct,
              firstSelect.value
            );

          selectedProduct = {
            id: "",
            title: "Any Screw",
            url: "",
            image:
              representativeColour?.image ||
              representativeProduct?.image ||
              null
          };

          selectedColour = {
            name: firstSelect.value,
            variantId: "",
            image:
              representativeColour?.image ||
              representativeProduct?.image ||
              null
          };
        } else {
          selectedProduct = findProduct(
            secondSelect.value
          );

          selectedColour = findColour(
            selectedProduct,
            firstSelect.value
          );
        }
      }

      showSelection();
    }

    modeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        mode = button.dataset.csSampleMode;

        modeButtons.forEach((modeButton) => {
          const isActive =
            modeButton === button;

          modeButton.classList.toggle(
            "is-active",
            isActive
          );

          modeButton.setAttribute(
            "aria-pressed",
            String(isActive)
          );
        });

        populateFirstSelect();
      });
    });

    firstSelect.addEventListener(
      "change",
      populateSecondSelect
    );

    secondSelect.addEventListener(
      "change",
      updateSelection
    );

    if (contactForm) {
      contactForm.addEventListener(
        "submit",
        (event) => {
          if (!selectedProduct || !selectedColour) {
            event.preventDefault();

            window.alert(
              "Please complete your sample selection before submitting the form."
            );
          }
        }
      );
    }

    populateFirstSelect();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseSampleRequest
    );
  } else {
    initialiseSampleRequest();
  }
})();